import { render, staticRenderFns } from "./TableFiles.vue?vue&type=template&id=4e8d0715&scoped=true"
import script from "./TableFiles.vue?vue&type=script&lang=js"
export * from "./TableFiles.vue?vue&type=script&lang=js"
import style0 from "./TableFiles.vue?vue&type=style&index=0&id=4e8d0715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d0715",
  null
  
)

export default component.exports